var React = require('react');

function Pages (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.66667 4.66667V23H23V4.66667H4.66667ZM21.1667 21.1667H6.5V9.25H21.1667V21.1667ZM18.4167 18.4167H9.25V17.5H18.4167V18.4167ZM18.4167 15.6667H9.25V14.75H18.4167V15.6667ZM18.4167 12.9167H9.25V12H18.4167V12.9167ZM20.25 2.83333H2.83333V20.25H1V1H20.25V2.83333Z","fill":"currentColor"}));
}

Pages.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Pages;

Pages.default = Pages;
